// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * smapi-ticketing-api
 * The SBB Swiss Mobility API - Ticketing is an interface that you can integrate into your own distribution system. Fare details are made available to you via this interface. There are two ways to use the service:  - Either integrate the SBB Swiss Mobility API as a full version, so that bookings are made directly via your distribution environment - Or use the Affiliate solution, with a link to the SBB webshop or SBB mobile  Before you request access to our API, please get in contact with SBB Digital Affiliates by sending an email stating your intentions and goal. Please note that the purpose of our API is to generate sales turnover through it. Offers only is not permitted due to the Look2Book Ratio. Please check out our GTC as well. On the right you can find the contact details and the links to the important websites.  IMPORTANT: The journey endpoints `Locations` and `Trips` will be deprecated by October 31, 2024 and are planned to be removed in December 2024. Please switch to the new endpoints `/v1/places`, `/v1/trips-collection` and `/v1/trips/{tripId}` of the new [SBB Swiss Mobility Journey API](https://developer-int.sbb.ch/apis/smapi-osdm-journey/information). 
 *
 * The version of the OpenAPI document: latest
 * Contact: digitalsales@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * The cheapest price for a given trip with its characteristics.
 * @export
 * @interface TripPrice
 */
export interface TripPrice {
    /**
     * Currency of the given price of the offer.
     * @type {string}
     * @memberof TripPrice
     */
    currency?: string;
    /**
     * Context information required by the services.
     * @type {Array<Link>}
     * @memberof TripPrice
     */
    links?: Array<Link>;
    /**
     * The id of the passenger for which the price is valid
     * @type {string}
     * @memberof TripPrice
     */
    passengerId?: string;
    /**
     * Cheapest price for this trip with the given characteristics.
     * @type {number}
     * @memberof TripPrice
     */
    price: number;
    /**
     * Product Id of this price quote.
     * @type {number}
     * @memberof TripPrice
     */
    productId: number;
    /**
     * The quality of service for this price.
     * @type {number}
     * @memberof TripPrice
     */
    qualityOfService: number;
    /**
     * Whether this is the price for a normal or a supersaver offer (bound to a connection; other restrictions may apply).
     * @type {boolean}
     * @memberof TripPrice
     */
    superSaver: boolean;
    /**
     * The tripId for the current price.
     * @type {string}
     * @memberof TripPrice
     */
    tripId: string;
}

/**
 * Check if a given object implements the TripPrice interface.
 */
export function instanceOfTripPrice(value: object): value is TripPrice {
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('qualityOfService' in value) || value['qualityOfService'] === undefined) return false;
    if (!('superSaver' in value) || value['superSaver'] === undefined) return false;
    if (!('tripId' in value) || value['tripId'] === undefined) return false;
    return true;
}

export function TripPriceFromJSON(json: any): TripPrice {
    return TripPriceFromJSONTyped(json, false);
}

export function TripPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'passengerId': json['passengerId'] == null ? undefined : json['passengerId'],
        'price': json['price'],
        'productId': json['productId'],
        'qualityOfService': json['qualityOfService'],
        'superSaver': json['superSaver'],
        'tripId': json['tripId'],
    };
}

  export function TripPriceToJSON(json: any): TripPrice {
      return TripPriceToJSONTyped(json, false);
  }

  export function TripPriceToJSONTyped(value?: TripPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'passengerId': value['passengerId'],
        'price': value['price'],
        'productId': value['productId'],
        'qualityOfService': value['qualityOfService'],
        'superSaver': value['superSaver'],
        'tripId': value['tripId'],
    };
}

